var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "box",
          attrs: {
            visible: _vm.dialogVisible,
            width: "400px",
            top: "15vh",
            "close-on-click-modal": false,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "header", attrs: { slot: "title" }, slot: "title" },
            [
              _c("div", {
                staticClass: "iconfont iconguanbi1",
                on: {
                  click: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              }),
              _vm._v(" "),
              _vm.info.title && _vm.info.title.length < 19
                ? _c("div", { staticClass: "title" }, [
                    _vm._v("\n        " + _vm._s(_vm.info.title) + "\n      "),
                  ])
                : _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.info.title,
                        placement: "bottom",
                      },
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.info.title) + "\n        "
                        ),
                      ]),
                    ]
                  ),
              _vm._v(" "),
              _vm.getYear(_vm.dateInfo.start, "yyyy") ==
                _vm.getYear(_vm.dateInfo.end, "yyyy") &&
              _vm.getYear(_vm.dateInfo.start, "MM-DD") !==
                _vm.getYear(_vm.dateInfo.end, "MM-DD")
                ? _c(
                    "div",
                    { staticClass: "time" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getYear(_vm.dateInfo.start, "M月DD日")) +
                          "(" +
                          _vm._s(_vm.getWeek(_vm.dateInfo.start)) +
                          ")\n        "
                      ),
                      _vm.info.all_day == 0
                        ? [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(_vm.dateInfo.start)
                                  .format("HH:mm:ss")
                              )
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(
                        "\n        - " +
                          _vm._s(_vm.getYear(_vm.dateInfo.end, "M月DD日")) +
                          "(" +
                          _vm._s(_vm.getWeek(_vm.dateInfo.end)) +
                          ")\n        "
                      ),
                      _vm.info.all_day == 0
                        ? [
                            _vm._v(
                              _vm._s(_vm.getYear(_vm.info.end_time, "HH:mm:ss"))
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm.getYear(_vm.dateInfo.start, "yyyy") !==
                  _vm.getYear(_vm.dateInfo.end, "yyyy")
                ? _c("div", { staticClass: "time" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getYear(_vm.dateInfo.start, "yyyy-MM-DD HH:mm:ss")
                        ) +
                        "\n        -\n        " +
                        _vm._s(
                          _vm.getYear(_vm.dateInfo.end, "yyyy-MM-DD HH:mm:ss")
                        ) +
                        "\n      "
                    ),
                  ])
                : _c("div", { staticClass: "time" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getYear(_vm.dateInfo.start, "M月DD日")) +
                        " (" +
                        _vm._s(_vm.getWeek(_vm.dateInfo.start)) +
                        ")\n        " +
                        _vm._s(_vm.getYear(_vm.dateInfo.start, "HH:mm")) +
                        " -\n        " +
                        _vm._s(_vm.getYear(_vm.dateInfo.end, "HH:mm")) +
                        "\n      "
                    ),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "content",
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px" } },
                [
                  _c("el-form-item", { attrs: { label: "组织人：" } }, [
                    _c("div", { staticClass: "flex" }, [
                      _c("img", {
                        staticClass: "img",
                        attrs: {
                          src: _vm.info.master ? _vm.info.master.avatar : "",
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "name b-color" }, [
                        _vm._v(
                          _vm._s(_vm.info.master ? _vm.info.master.name : "--")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.info.user && _vm.info.user.length !== 0
                    ? _c("el-form-item", { attrs: { label: "参与者：" } }, [
                        _c(
                          "div",
                          { staticClass: "user-flex" },
                          _vm._l(_vm.info.user, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "flex mr10 finish" },
                              [
                                _c("img", {
                                  staticClass: "img",
                                  attrs: { src: item.avatar, alt: "" },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name b-color" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _vm._v(" "),
                                item.finish == 0
                                  ? _c("i", {
                                      staticClass: "el-icon-remove finish-ab",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.finish == 2
                                  ? _c("i", {
                                      staticClass: "el-icon-error finish-ab",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.finish == 3
                                  ? _c("i", {
                                      staticClass: "el-icon-success finish-ab",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.finish == 1
                                  ? _c("img", {
                                      staticClass: "finish-ab",
                                      attrs: {
                                        src: require("../../../../assets/images/accept.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _c("el-form-item", { attrs: { label: "参与者：" } }, [
                        _c("div", { staticClass: "flex finish" }, [
                          _c("img", {
                            staticClass: "img",
                            attrs: {
                              src: _vm.info.master
                                ? _vm.info.master.avatar
                                : "",
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "finish-ab",
                            attrs: {
                              src: require("../../../../assets/images/accept.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name b-color" }, [
                            _vm._v(
                              _vm._s(
                                _vm.info.master ? _vm.info.master.name : "--"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                  _vm._v(" "),
                  _vm.info.cid == 3 || _vm.info.cid == 4
                    ? _c("el-form-item", { attrs: { label: "合同名称：" } }, [
                        _c(
                          "span",
                          {
                            staticClass: "name b-color cursor",
                            on: {
                              click: function ($event) {
                                return _vm.openContract()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.info.linkName))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.info.cid == 2
                    ? _c("el-form-item", { attrs: { label: "客户名称：" } }, [
                        _c(
                          "span",
                          {
                            staticClass: "name b-color cursor",
                            on: { click: _vm.openCustomer },
                          },
                          [_vm._v(_vm._s(_vm.info.linkName))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "日程描述：" } }, [
                    _vm.info.content
                      ? _c("div", {
                          staticClass: "name",
                          domProps: { innerHTML: _vm._s(_vm.info.content) },
                        })
                      : _c("div", { staticClass: "name" }, [_vm._v("--")]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "日程类型：" } }, [
                    _c("span", { staticClass: "name b-color" }, [
                      _vm._v(_vm._s(_vm.info.type ? _vm.info.type.name : "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "提醒时间：" } }, [
                    [2, 3, 4, 5].includes(_vm.info.cid)
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$moment(_vm.info.remind.remind_day)
                                .format("M月DD日")
                            ) +
                              "\n            " +
                              _vm._s(
                                _vm.info.remind
                                  ? _vm.info.remind.remind_time
                                  : "09:00:00"
                              )
                          ),
                        ])
                      : _c("span", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.info.remindInfo
                                ? _vm.info.remindInfo.text
                                : "--"
                            )
                          ),
                        ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.commentList.length !== 0
                ? _c("div", { staticClass: "splitLine mt20" })
                : _vm._e(),
              _vm._v(" "),
              _vm.commentList.length !== 0
                ? _c(
                    "div",
                    { staticClass: "comment" },
                    [
                      _vm._v("\n        日程评论：\n        "),
                      _c("comment-list", {
                        attrs: { commentList: _vm.commentList },
                        on: {
                          replyFn: _vm.replyFn,
                          commentDel: _vm.commentDel,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.infoId == _vm.userId
            ? _c(
                "div",
                { staticClass: "mt20 footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { plain: "", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onDelete(_vm.info)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                  _vm._v(" "),
                  _vm.info.cid !== 2 &&
                  _vm.info.cid !== 3 &&
                  _vm.info.cid !== 4 &&
                  _vm.info.cid !== 5
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.onEdit(_vm.info)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShow(_vm.info)
                    ? _c(
                        "el-button",
                        {
                          class: _vm.info.finish == 3 ? "primary" : "btn",
                          staticStyle: { width: "100%" },
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.putStatus("完成", 3)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.info.finish == 3 ? "已完成" : "完成")
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "评论",
                        placement: "top",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "commentImg",
                        attrs: {
                          src: require("../../../../assets/images/comment.png"),
                          alt: "",
                        },
                        on: { click: _vm.openComment },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "mt20 footer" },
                [
                  _c(
                    "el-button",
                    {
                      class: _vm.info.finish == 1 ? "success" : "btn",
                      staticStyle: { width: "148px" },
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.putStatus("已接受", 1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.finish == 1 ? "已接受" : "接受"))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      class: _vm.info.finish == 2 ? "danger" : "btn",
                      staticStyle: { width: "148px" },
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.putStatus("拒绝", 2)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.finish == 2 ? "已拒绝" : "拒绝"))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      class: _vm.info.finish == 0 ? "warning" : "btn",
                      staticStyle: { width: "148px" },
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.putStatus("待定", 0)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.finish == 0 ? "已待定" : "待定"))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      class: _vm.info.finish == 3 ? "primary" : "btn",
                      staticStyle: { width: "148px" },
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.putStatus("完成", 3)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.finish == 3 ? "已完成" : "完成"))]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "commentImg",
                    attrs: {
                      src: require("../../../../assets/images/comment.png"),
                      alt: "",
                    },
                    on: { click: _vm.openComment },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          false
            ? _c(
                "div",
                { staticClass: "mt20 footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "148px", "font-size": "16px" },
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onDelete(_vm.info)
                        },
                      },
                    },
                    [_vm._v("+ 加入日程")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.deleteText == 1 ? "删除重复性日程" : "编辑重复性日程",
            visible: _vm.deleteVisible,
            width: "20%",
            top: "20vh",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteVisible = $event
            },
          },
        },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "radio",
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            [
              _c("el-radio", { attrs: { label: "0" } }, [_vm._v("此日程")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "1" } }, [
                _vm._v("此日程及后续日程"),
              ]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "2" } }, [_vm._v("所有日程")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.returnFn } },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: { click: _vm.deleteFn },
                },
                [_vm._v(_vm._s(_vm.deleteText == 1 ? "删除" : "编辑"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("message-handle-popup", {
        ref: "messageHandlePopup",
        attrs: { detail: _vm.detail },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "record",
          attrs: {
            title: "添加跟进记录",
            visible: _vm.dialogShow,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
          },
        },
        [
          _c("recordUpload", {
            attrs: { "form-info": _vm.formInfo },
            on: { change: _vm.recordChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "comment-dialog",
          attrs: {
            visible: _vm.commentShow,
            top: "20vh",
            title: _vm.commentTitle,
            width: "400px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.commentShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "mt14 ml14" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入内容",
                  maxlength: "256",
                },
                model: {
                  value: _vm.textarea,
                  callback: function ($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.commentCancel } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.commentSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { parameterData: _vm.parameterData },
        on: { isOk: _vm.isOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }